import { useEffect, useState } from 'react';
import { formattingNumber } from 'utils';
import { StyledBundlePrice } from './style';
import { PMBundlePriceProps } from 'utils/types';
import { Box } from '@mui/material';

export const WhispersBundlePrice: React.FC<PMBundlePriceProps> = ({
  price,
  isPreview = false,
  bundleButtonColor,
  bundleButtonTextColor = 'white',
}) => {
  const [finalPrice, setFinalPrice] = useState('');

  useEffect(() => {
    const formattedPrice = formattingNumber(
      price.price,
      price,
      price.isCents,
      price.multiplier,
      !isPreview,
    );
    setFinalPrice(formattedPrice);
  }, [price, isPreview]);

  return (
    <StyledBundlePrice
      bundleButtonColor={bundleButtonColor}
      bundleButtonTextColor={bundleButtonTextColor}
      direction={price.symbolPosition === 'Right' ? 'rtl' : 'ltr'}
    >
      <Box
        className="whispers__price-button totalPrice"
        gap={price.spacing ? '4px' : '0'}
      >
        <span>{price.currencySymbol}</span>
        <span className="actual-price">{finalPrice}</span>
      </Box>
    </StyledBundlePrice>
  );
};
